export enum QuestionType {
  CHECKBOX = 'checkbox',
  RADIOBUTTON = 'radiobutton',
  TEXT_INPUT = 'text_input',
}
